// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components'
import { StyleSheetTypes } from 'Content/Shared/Components/Elements'

// COMPONENTS IMPORTS //
import FieldItem from './FieldItem/FieldItem'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'
import SocialMediaSection from '../../SocialMediaSection/SocialMediaSection'

// EXTRA IMPORTS //
import { iPadResolution } from 'Content/Shared/Styles/Theme'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const Info: React.FC<PropsType> = () => {
  const fields = [
    {
      text: 'swift.uix@gmail.com',
      icon: 'fas fa-envelope',
    },
    {
      text: ' Alicante, Spain',
      icon: 'fas fa-map-marker-alt',
    },
    {
      text: '+34 674 843 350',
      icon: 'fas fa-phone-volume',
    },
  ]

  return (
    <Wrapper>
      <Title>Contact information</Title>
      {fields.map((value) => (
        <FieldItem text={value.text} icon={value.icon} />
      ))}
      <SocialWrap>
        <SocialMediaSection />
      </SocialWrap>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${iPadResolution}px) {
    align-items: center;
  }
`

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
  align-self: center;
`

const SocialWrap = styled.div`
  margin-top: 35px;

  @media (min-width: ${iPadResolution}px) {
    margin-top: 45px;
    margin-left: -20px;
  }
`

export default React.memo(Info, memoComparison)
